import { render, staticRenderFns } from "./ErrorResolutionUI.vue?vue&type=template&id=57f2c24e&scoped=true&"
import script from "./ErrorResolutionUI.vue?vue&type=script&lang=js&"
export * from "./ErrorResolutionUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f2c24e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
